import { Component, OnInit,TemplateRef,Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Item } from '../../entities/item.entities';
import { CartService } from '../../services/cart.service';

@Component({
  selector: 'app-cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.css']
})
export class CartModalComponent implements OnInit {

  @Input() id : any;
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService, private cartService: CartService) { }

  ngOnInit() {
  }
  openModal(template: TemplateRef<any>) {
    this.cartService.pushCart(this.id)
    this.modalRef = this.modalService.show(template);
  }
  addCart(id: string) {
    this.cartService.pushCart(id)
  }
  deleteCart(value: string) {
    this.cartService.decrementCart(value)
  }
  deleteItem(i) {
    this.cartService.deleteItem(i)
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/cart-modal/cart-modal.component.ts